// extracted by mini-css-extract-plugin
export default {"error":"AdminChangePasswordPage_error__EumTF","container":"AdminChangePasswordPage_container__rWHTI"};